import { VoidACHTransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useVoidACHTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  async function voidACHTransaction(params: VoidACHTransactionRequest) {
    try {
      setFetching(true);
      const res = await api.postVoidACHTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, voidACHTransaction };
}
